import Util from '@/assets/libs/util'

export default {
  state: {
    user: Util.getLocalVar('storedUser') || null
  },
  mutations: {
    setUser (state, user) {
      state.user = user
      Util.setLocalVar('storedUser', user)
    },
    updateUserProfile (state, data) {
      state.user.consumer = {
        cellphone: data.cellphone,
        email: data.email,
        cpf: state.user.consumer.cpf,
        name: data.name,
        zipCode: data.address.zipCode,
        street: data.address.street,
        number: data.address.number,
        complement: data.address.complement,
        neighborhood: data.address.neighborhood,
        city: data.address.city,
        state: data.address.state
      }

      state.user.consumerName = data.name

      Util.setLocalVar('storedUser', state.user)
    }
  },
  actions: {
    setUser ({ commit }, user) {
      commit('setUser', user)
    },
    updateUserProfile ({ commit }, data) {
      console.log('updateUserProfile', data)
      commit('updateUserProfile', data)
    }
  },
  getters: {
    getUser: state => state.user,
    getUserName: state => state.user.consumerName,
    getUserClientCode: state => state.user.client
  }
}
